import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanLoad, CanActivate {
    constructor(private authenticationService: AuthService) { }

    public canLoad(): Observable<boolean> {
        if (this.authenticationService.loggedIn) {
            return observableOf(true);
        }

        return this.authenticationService.isAlive()
            .pipe(tap((response: boolean) => {
                if (!response) {
                    this.authenticationService.logout();
                }
            }));
    }

    public canActivate(): Observable<boolean> {
        return this.canLoad();
    }
}
